import posthog from 'posthog-js'

export const trackEvent = (name, props = {}) => {
  if (!import.meta.env.PROD) return
  if (!posthog.__loaded) return
  posthog.capture(name, props)
}
